<section class="custom-blocks-cta-section hero-gradient">
    <div class="generic-container custom-blocks-container">
        <div class="content-wrapper">
            <h2 class="cta-title">Custom Your Blocks</h2>
            <p class="cta-description">
                Make it yours! Personalize your toy blocks for a truly one-of-a-kind creation. Our design studio lets
                you customize colors, shapes, and patterns.
            </p>
            <div class="button-group">
                <a routerLink="/designer" class="button-link">
                    <app-button variant="outline" size="xl" buttonClass="cta-browse-products-btn">
                        Start Designing
                    </app-button>
                </a>
                <a routerLink="/products" [queryParams]="{ category: 'block' }" class="button-link">
                    <app-button variant="white" size="xl" buttonClass="cta-start-designing-btn hover-bounce">
                        Customize
                    </app-button>
                </a>
            </div>
        </div>
    </div>
</section>
